import { createSlice } from "@reduxjs/toolkit";
import {    home_finance_ledgerThunk } from "./thunk";


export const initialState = {
  home_financeLedgerData: [],
  home_financeLedgerError: {
    code: null,
    message: '',
    data: null
  },
  home_financeLedgerLoading: false,
  
  
};

const Home_Finance_Ledger = createSlice({
  name: "Home_Finance_Ledger",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(home_finance_ledgerThunk.pending, (state) => {
      state.home_financeLedgerLoading = true ;
      state.home_financeLedgerError = initialState.home_financeLedgerError; 
  });
    builder.addCase(home_finance_ledgerThunk.fulfilled, (state, action) => {
        state.home_financeLedgerData = action.payload.data;
        state.home_financeLedgerLoading = false ;
    });
    builder.addCase(home_finance_ledgerThunk.rejected, (state, action) => {
      state.home_financeLedgerError = {
        code: action.payload?.code || null,
        message: action.payload?.message || "An unknown error occurred",
        data: action.payload?.data || null
      };
        state.home_financeLedgerLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = Home_Finance_Ledger.actions

export default Home_Finance_Ledger.reducer;